export const USER_ROLE = {
    BASE_PATH: '/user-management/user-roles/',
    GET_ALL: '/user-roles',
    CREATE: '/user-roles/create',
    UPDATE: '/user-roles/update/',
    DELETE: '/user-roles/delete/',
    ADD_NEW_TITLE: 'Add New User Role',
};
